import { Component, OnInit, OnDestroy } from '@angular/core';
import { DomService } from 'app/components/dom/dom.service';
import { CatalogueService } from 'app/components/catalogue/catalogue.service';
import { SearchService } from 'app/components/search/search.service';
import { UtilsService } from 'app/components/utils/utils.service';
import { ProductsService } from 'app/components/products/products.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ExhitorsService } from 'app/components/exhitors/exhitors.service';
import {AlertService} from "../../components/alert/alert.service";


@Component({
  selector: 'app-exhibitor-backoffice-product-detail-edit',
  templateUrl: './exhibitor-backoffice-product-detail-edit.component.html',
  styleUrls: ['./exhibitor-backoffice-product-detail-edit.component.css']
})
export class ExhibitorBackofficeProductDetailEditComponent implements OnInit, OnDestroy {

  loader: any = {
    count: 0
  };
  alertType: string = '';
  alertMessage: string = '';

  exhibitorData: object = {
    exhibitor: {},
    product: {},
    exhibitorId: null
  };

  unifiedCategories: any = [];

  productId;
  exhibitorId;
  eventName;
  productCategories;
  hierarchicalProperties;
  frontendLink: string = '';
  buttonLink: string = '';
  activeTab: number = 1;

  isDefaultLangValid = false;

  constructor(private activatedRoute:ActivatedRoute, public catalogueService:CatalogueService, private productsService:ProductsService, private searchService:SearchService,
    public utilsService:UtilsService, private router:Router, private domService: DomService, private exhitorsService: ExhitorsService, private alertService: AlertService) {

    this.exhibitorId = this.activatedRoute.snapshot.paramMap.get('exhibitorId') || null;
    this.productId = this.activatedRoute.snapshot.paramMap.get('productId') || null;
    this.eventName = this.activatedRoute.snapshot.paramMap.get('event') || null;
    this.buttonLink = this.eventName + '/exhibitor-backoffice/exhibitors/' + this.exhibitorId + '/products/' + this.productId + '/product-detail'
    this.frontendLink = this.eventName + '/product/' + this.productId + '/detail'

  }


  unifyCategories(categories) {
    for (let i = 0; i < categories.length; i++) {
      this.unifiedCategories.push(categories[i]);
      if (categories[i].childHierarchicalProperties) {
        this.unifyCategories(categories[i].childHierarchicalProperties);
      }
    }
  }

  getProduct(getProductIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.productsService.getProduct(getProductIn)
      .subscribe((data: object) => {
        this.getProductOk(data);
      },
        error => {
          this.getProductError(error);
        });

  }

  getProductOk(data) {
    this.loader.count--;
    this.exhibitorData['product'] = data;
  }

  getProductError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }



  getProductsCategories(getProductsCategoriesIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.productsService.getProductsCategories(getProductsCategoriesIn)
      .subscribe((data: object) => {
        this.getProductsCategoriesOk(data);
      },
        error => {
          this.getProductsCategoriesError(error);
        });

  }

  getProductsCategoriesOk(data) {

    this.loader.count--;
    this.productCategories = data;
    this.unifyCategories(data.masterProperties);

  }

  getProductsCategoriesError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  getHierarchicalProperties(getHierarchicalPropertiesIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.productsService.getHierarchicalProperties(getHierarchicalPropertiesIn)
      .subscribe((data: object) => {
        this.getHierarchicalPropertiesOk(data);
      },
        error => {
          this.getHierarchicalPropertiesError(error);
        });

  }

  getHierarchicalPropertiesOk(data) {

    this.loader.count--;
    this.hierarchicalProperties = data;
    this.unifyCategories(data);

  }

  getHierarchicalPropertiesError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  goTo(url) {
    this.router.navigate([url]);
  }

  setTab(tab) {
    this.activeTab = tab;
  }

  saveProduct(saveProductIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.productsService.saveProduct(saveProductIn)
      .subscribe((data: object) => {
        this.saveProductOk(data);
      },
        error => {
          this.saveProductError(error);
        });

  }

  saveProductOk(data) {

    this.loader.count--;

    if (this.productId) {
      this.router.navigate([this.buttonLink]);
    } else {
      this.productId = data['id'];
      let editLink = this.catalogueService.getProperty('id') + '/' + this.eventName + '/exhibitor-backoffice/exhibitors/' + this.exhibitorId + '/products/' + this.productId + '/product-detail-edit';
      this.router.navigate([editLink]);
    }

  }

  saveProductError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  saveBtn() {

    if (!this.isDefaultLangValid) {
      let alertData = {
        type: 'error',
        message: 'EXHIBITOR_BACKOFFICE_EXHIBITOR_DETAIL_EDIT.ERRORS.MANDATORY_FIELDS_DEFAULT_LANG'
      };
      this.alertService.addAlert(alertData);
      return;
    }

    let saveProductIn = {
      descriptionTranslations: this.getTranslationsByProperty('description'),
      eventName: this.eventName,
      exhibitorId: parseInt(this.exhibitorId),
      hierarchicalProperties: this.exhibitorData['selectedCategories'],
      nameTranslations: this.getTranslationsByProperty('name'),
      properties: [],
      publicationOrder: this.exhibitorData['product']['publicationOrder'],
      videoUrl: this.exhibitorData['product']['videoUrl']
    }

    if (this.productId) {
      saveProductIn['id'] = this.productId;
    } else {
      saveProductIn['published'] = false;
    }

    this.saveProduct(saveProductIn);

  }

  cancel(){

    if (this.productId) {
      this.router.navigate([this.buttonLink]);
    } else {
      let cancelLink = this.eventName + '/exhibitor-backoffice/exhibitors/' + this.exhibitorId + '/products';
      this.router.navigate([cancelLink]);
    }

  }

  getTranslationsByProperty(property) {

    let translations = {};
    this.exhibitorData['product']['translations'] = this.exhibitorData['product']['translations'] || [];

    for(let i = 0; i < this.exhibitorData['product']['translations'].length; i++) {
      let translation = this.exhibitorData['product']['translations'][i];
      translations[translation['language']] = translation[property];
    }

    return translations;

  }

  getExhibitorCataloguePlan(getExhibitorCataloguePlanIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.exhitorsService.getExhibitorCataloguePlan(getExhibitorCataloguePlanIn)
      .subscribe((data: object) => {
        this.getExhibitorCataloguePlanOk(data);
      },
        error => {
          this.getExhibitorCataloguePlanError(error);
        });

  }

  getExhibitorCataloguePlanOk(data) {

    this.loader.count--;
    this.exhibitorData['exhibitor']['cataloguePlanId'] = data['id'];
    this.exhibitorData['imageExhibitorLimit'] = data['imageExhibitorLimit'];
    this.exhibitorData['imageProductLimit'] = data['imageProductLimit'];
  }

  getExhibitorCataloguePlanError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  onDefaultLangValidityChange(valid: boolean) {
    this.isDefaultLangValid = valid;
  }

  ngOnInit() {

    this.domService.addClassToBody('bg-gray');
    this.exhibitorData['exhibitorId'] = this.exhibitorId;
    this.exhibitorData['eventName'] = this.eventName;

    if (this.productId) {

      this.exhibitorData['productId'] = this.productId;

      let getProductIn = {
        productId: this.productId,
      };

      let getProductsCategoriesIn = {
        productId: this.productId
      };

      let getExhibitorCataloguePlanIn = {
        exhibitorId: this.exhibitorId
      }

      this.getProduct(getProductIn);
      this.getProductsCategories(getProductsCategoriesIn);
      this.getExhibitorCataloguePlan(getExhibitorCataloguePlanIn);

    }

  }

  ngOnDestroy() {
    this.domService.removeClassFromBody('bg-gray');
  }

}
